import { actionCopyDe } from "./actionCopy";
import { listCopyDe } from "./listCopy";

export const profileCopyDe = {
    title: "Profil",
    description: "Verwalten Sie Ihr Profil und Ihre Einstellungen",
    contactDetails: "Kontaktdaten",
    name: listCopyDe.name,
    titleLabel: "Anrede",
    selectPlaceholder: "Auswählen",
    requiredField: "Pflichtfeld",
    firstNameRequired: "Vorname ist erforderlich",
    lastNameRequired: "Nachname ist erforderlich",
    firstName: "Vorname",
    lastName: "Nachname",
    noName: "Kein Name",
    dateOfBirth: listCopyDe.dateOfBirth,
    dateOfBirthFormatDescription: "Bitte verwenden Sie das Format TT MM JJJJ.",
    dobPlaceholderDay: "TT",
    dobPlaceholderMonth: "MM",
    dobPlaceholderYear: "JJJJ",
    dobDayRequired: "Tag ist erforderlich",
    dobMonthRequired: "Monat ist erforderlich",
    dobYearRequired: "Jahr ist erforderlich",
    dobMaxDaysInMonth: "Ein Monat hat maximal 31 Tage",
    dobMonthsInYear: "Ein Jahr hat nur 12 Monate",
    dobYearTooEarly: "Dieses Jahr liegt zu weit zurück",
    dobYearInFuture: "Das liegt in der Zukunft!",
    noDateOfBirth: "Kein Geburtsdatum",
    email: listCopyDe.email,
    noEmail: "Keine E-Mail",
    updateEmail: "E-Mail aktualisieren",
    validEmailAddress: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    accountSignInEmailRequired: "Geben Sie die Anmelde-E-Mail-Adresse ein, die Sie ändern möchten",
    newEmailDifferentFromSignIn:
        "Die neue E-Mail-Adresse muss sich von der bisherigen Anmelde-E-Mail-Adresse unterscheiden",
    newEmailDifferentFromCurrent: "Die neue E-Mail-Adresse muss sich von Ihrer aktuellen E-Mail-Adresse unterscheiden",
    differentEmailAddress: "Geben Sie eine andere E-Mail-Adresse ein",
    noSignInEmailToChange: "Keine Anmelde-E-Mail-Adresse zum Ändern vorhanden",
    emailUpdatedSuccessfully: "E-Mail-Adresse erfolgreich aktualisiert",
    emailUpdateFailed: "E-Mail-Adresse konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
    emailSavedToProfile: "E-Mail-Adresse in Ihrem Profil gespeichert",
    emailSaveToProfileFailed:
        "E-Mail-Adresse konnte nicht in Ihrem Profil gespeichert werden. Bitte versuchen Sie es erneut.",
    loading: actionCopyDe.loading,
    profileEmailIntro: (email) => `Profil-E-Mail ist ${email}.`,
    profileEmailIntroSuffix: "Geben Sie unten die neue Adresse ein.",
    signInEmailDiffersHelp:
        "Wenn die Anmelde-E-Mail von der Profil-E-Mail abweicht (zum Beispiel nach einem Synchronisationsproblem), verwenden Sie das optionale Feld.",
    noProfileEmailReplaceDescription:
        "Dieses Profil hat keine E-Mail-Adresse. Geben Sie die zu ersetzende Anmelde-E-Mail-Adresse und dann die neue E-Mail-Adresse ein.",
    signInEmailOnlyIfDifferent: "Anmelde-E-Mail (nur wenn anders als im Profil)",
    signInEmail: "Anmelde-E-Mail",
    leaveBlankIfSameAsProfile: "Leer lassen, wenn identisch mit dem Profil",
    newEmail: "Neue E-Mail",
    emailAddressToChangeTo: "E-Mail-Adresse, zu der gewechselt werden soll",
    accountSignInEmailIntro: (email) =>
        `Ihre Anmelde-E-Mail ist ${email}, aber Ihr Profil zeigt sie noch nicht an. Sie können sie jetzt in Ihrem Profil speichern.`,
    saveEmailToProfile: "E-Mail im Profil speichern",
    saveEmailFirstDescription:
        "Nachdem dies gespeichert wurde, können Sie die Adresse in diesem Dialog ändern. Um zuerst mit einem Bestätigungslink zu einer anderen E-Mail zu wechseln, verwenden Sie",
    noProfileEmailAddDescription:
        "Ihr Profil hat noch keine E-Mail-Adresse. Fügen Sie unten eine hinzu, zum Beispiel wenn Sie sich mit Ihrer Telefonnummer registriert haben.",
    profileEmailLink: "Profil - E-Mail",
    noEmailOnAccountPhoneSignup:
        "Noch keine E-Mail-Adresse für dieses Konto vorhanden (zum Beispiel wenn Sie sich mit Ihrer Telefonnummer registriert haben)",
    currentEmail: "Aktuelle E-Mail",
    emailConfirmationSecurityDescription:
        "Wir senden Ihnen einen Bestätigungslink per E-Mail. Aus Sicherheitsgründen ändert sich nichts, bis Sie diesen Link öffnen.",
    emailConfirmationSent:
        "Bestätigung gesendet - prüfen Sie Ihr neues Postfach auf einen Link von uns. Ihre Anmelde-E-Mail ändert sich erst nach der Bestätigung.",
    emailChangeStartFailed:
        "Die Änderung der E-Mail-Adresse konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
    sending: actionCopyDe.sending,
    sendConfirmationEmail: "Bestätigungs-E-Mail senden",
    phone: "Telefon",
    noPhoneNumber: "Keine Telefonnummer",
    notifications: "Benachrichtigungen",
    notificationPreferences: "Benachrichtigungseinstellungen",
    notificationPreferencesMissing: "Benachrichtigungseinstellungen fehlen",
    notificationPreferencesNotSpecified: "Benachrichtigungseinstellungen nicht angegeben",
    notificationPreferencesDescription: "Wählen Sie aus, wie Sie Benachrichtigungen erhalten möchten",
    notificationsEnabled: "Aktiviert",
    notificationsDisabled: "Deaktiviert",
    notificationsDisabledWarningPatient:
        "Wir empfehlen, E-Mail- oder SMS-Benachrichtigungen zu aktivieren, damit Sie wichtige Erinnerungen zu Tagebucheinträgen und Nachrichten erhalten.",
    notificationsDisabledWarningClinician:
        "Wir empfehlen, E-Mail- oder SMS-Benachrichtigungen zu aktivieren, damit Sie wöchentliche Zusammenfassungen zum Fortschritt Ihrer Patientinnen und Patienten erhalten.",
    notificationPreferencesSaved: "Benachrichtigungseinstellungen gespeichert",
    notificationPreferencesSaveFailed: "Benachrichtigungseinstellungen konnten nicht gespeichert werden",
    appearance: "Darstellung",
    darkMode: "Dunkler Modus",
    darkModeDescription: "Dunklen Hintergrund in der App verwenden.",
    switchToDarkMode: "Zum dunklen Modus wechseln",
    switchToLightMode: "Zum hellen Modus wechseln",
    language: "Sprache",
    languageDescription: "Wählen Sie die Sprache für Menüs, Schaltflächen und Erinnerungen.",
    chooseLanguage: "Sprache auswählen",
    otherActions: "Weitere Aktionen",
    billingAndSubscription: "Abrechnung und Abonnement",
    hospitalDetails: "Klinikdetails",
    clinicianNumberLabel: "Behandlernummer",
    clinicianNumberDescription: "Dies ist Ihre GMC- oder HCPC-Nummer",
    noClinicianNumber: "Keine Behandlernummer",
    myOrganisations: "Meine Organisationen",
    myTeam: "Team",
    teamPageDescription:
        "Alle in Ihren Organisationen. Laden Sie Kolleginnen und Kollegen ein und legen Sie eine Standardkontaktperson fest.",
    secretaryDefaultHelpTitle: "Standardkontaktperson",
    secretaryDefaultHelp:
        "Ihre Standardkontaktperson für eine Organisation wird als Kontakt vorausgefüllt, wenn Sie eine Patientin oder einen Patienten einladen. Die zuerst hinzugefügte Person wird automatisch Standard. Sie können das in der Tabelle ändern.",
    secretaryDefaultColumnHelp:
        "Wird als Kontaktperson verwendet, wenn Sie Patientinnen und Patienten in diese Organisation einladen.",
    filterRole: "Rolle",
    filterOrganisation: "Organisation",
    filterAddedBy: "Hinzugefügt von",
    filterAllRoles: "Alle Rollen",
    filterAllOrganisations: "Alle Organisationen",
    filterAllAddedBy: "Alle",
    filterInvitedByMe: "Von mir eingeladen",
    filterNotInvitedByMe: "Nicht von mir eingeladen",
    filterFavouritesOnly: "Nur Favoriten",
    filters: actionCopyDe.filters,
    filterTeamAria: "Team filtern",
    teamFilterTitle: "Filter",
    teamFilterDescription: "Filtern Sie diese Liste nach Rolle, Organisation und Favoriten.",
    selectRoles: "Rollen auswählen",
    selectOrganisations: "Organisationen auswählen",
    columnsButton: actionCopyDe.columns,
    columnName: listCopyDe.name,
    columnRole: listCopyDe.role,
    columnOrganisation: listCopyDe.organisation,
    columnAddedBy: "Hinzugefügt von",
    columnDefaultSecretary: "Standardkontaktperson",
    columnFavourite: "Favorit",
    invitedByYou: "Von Ihnen eingeladen",
    addUser: "Benutzer hinzufügen",
    membersShown: (count) => `${count} ${count === 1 ? "Mitglied" : "Mitglieder"}`,
    defaultForOrganisation: (organisationName) => `Standard für ${organisationName}`,
    setAsDefaultForOrganisation: (organisationName) => `Als Standard festlegen für ${organisationName}`,
    viewAll: "Alle anzeigen",
    teamLabel: "Team",
    staffCount: (count) => `${count} Mitarbeitende`,
    memberCount: (count) => `${count} ${count === 1 ? "Mitglied" : "Mitglieder"}`,
    favouritesCount: (count) => `${count} Favoriten`,
    moreTeamMembers: (count) => `+${count} weitere Teammitglieder`,
    noTeamMembersYet: "Noch keine Teammitglieder",
    searchTeamPlaceholder: "Suchen...",
    searchTeamAria: "Teammitglieder suchen",
    closeSearch: "Suche schließen",
    openSearch: "Suche öffnen",
    allStaff: "Alle Mitarbeitenden",
    invitedTab: "Eingeladen",
    favouritesTab: "Favoriten",
    noTeamMembersFound: "Keine Teammitglieder gefunden.",
    noFavouritesYet: "Noch keine Favoriten.",
    noInvitesYet: "Sie haben noch keine Benutzer eingeladen.",
    inviteColleaguesToBuildTeam: "Laden Sie Kolleginnen und Kollegen ein, um Ihr Team aufzubauen",
    manageTeam: "Team verwalten",
    secretaryOrganisationsLabel: "Sekretariatsorganisationen",
    secretaryDefaultBadge: "Standard",
    setAsDefaultSecretary: "Als Standard festlegen",
    clearDefaultSecretary: "Standard entfernen",
    addAsMySecretary: "Als meinen Sekretär hinzufügen",
    removeAsMySecretary: "Entfernen",
    addSecretaryForOrganisation: "Sekretär hinzufügen",
    inviteNewSecretary: "Neuen Sekretär einladen",
    chooseExistingSecretary: "Aus Organisation auswählen",
    chooseExistingSecretaryTitle: "Sekretär auswählen",
    noOtherSecretariesInOrganisation: "Keine weiteren Sekretäre in dieser Organisation gefunden.",
    inviteUser: "Benutzer einladen",
    diaryUsageUsedLabel: "Nutzung",
    diaryUsageUnlimited: "Unbegrenzte Tagebücher",
    diaryUsageAtCapHint:
        "Sie haben Ihr Tagebuch-Limit für diesen Zeitraum erreicht. Upgraden Sie Ihren Plan, um weitere Patienten einladen zu können.",
    changePassword: "Passwort ändern",
    logout: "Abmelden",
    help: "Hilfe",
    menu: "Menü",
    close: actionCopyDe.close,
    contactSupportPrompt: "Unklar oder brauchen Sie Hilfe?",
    contactSupport: "Support kontaktieren",
    incompleteTitle: "Profil unvollständig",
    incompleteMessage:
        "Um Patient Watch zu nutzen, vervollständigen Sie zuerst Ihr Profil und ergänzen Sie alle als fehlend markierten Felder.",
    profileCompletionLabel: (progress) => `Profilfortschritt ${progress} %`,
    addNextMissingField: "Profil vervollständigen",
    addMissingName: "Namen hinzufügen",
    addMissingDateOfBirth: "Geburtsdatum hinzufügen",
    addMissingEmail: "E-Mail hinzufügen",
    addMissingPhone: "Telefonnummer hinzufügen",
    addMissingOrganisation: "Organisation hinzufügen",
    addMissingNotifications: "Benachrichtigungen hinzufügen",
    navProfileDescription: "Aktualisieren Sie die Informationen, die Patient Watch benötigt.",
    navDiaryLabel: "Tagebuch",
    navDiaryDescription: "Tagebücher, mit denen Patientinnen und Patienten ihre Symptome verfolgen.",
    goToDiary: "Zum Tagebuch",
    addDoneSeeProgress: "Erledigtes hinzufügen und Fortschritt sehen",
    goToDiaries: "Zu den Tagebüchern",
    seeResults: "Ergebnisse anzeigen",
    seeDiaries: "Tagebücher anzeigen",
    onboarding: "Einrichtung",
    onboardingNameTitle: "Wie lautet Ihr Name?",
    onboardingNameDescription: "So erkennt man Sie in Patient Watch.",
    onboardingDateOfBirthTitle: "Wie lautet Ihr Geburtsdatum?",
    onboardingDateOfBirthDescription: "Damit ordnen wir Ihre Gesundheitsdaten sicher zu.",
    onboardingEmailTitle: "Wie lautet Ihre E-Mail-Adresse?",
    onboardingEmailDescription:
        "Wir verwenden diese nur für Ihr Patient-Watch-Konto und wichtige Nachrichten zur Versorgung.",
    onboardingPhoneTitle: "Wie lautet Ihre Telefonnummer?",
    onboardingPhoneDescription: "SMS-Erinnerungen helfen Ihnen, Formulare rechtzeitig auszufüllen.",
    onboardingNotificationsTitle: "Wie sollen wir Sie erinnern?",
    beginOnboarding: "Einrichtung beginnen",
    onboardingSignedOutDescription: "Klicken Sie auf Weiter, um Ihre Angaben zu ergänzen.",
    continue: actionCopyDe.continue,
    next: actionCopyDe.next,
    save: actionCopyDe.save,
    cancel: actionCopyDe.cancel,
    skip: actionCopyDe.skip,
    skipConfirmTitle: "Sind Sie sicher, dass Sie diesen Schritt überspringen möchten?",
    skipEmailDescription:
        "E-Mail wird für wichtige Benachrichtigungen verwendet. Wenn Sie diesen Schritt überspringen, erhalten Sie möglicherweise keine rechtzeitigen Updates.",
    skipSmsDescription:
        "SMS wird für wichtige Benachrichtigungen verwendet. Wenn Sie diesen Schritt überspringen, erhalten Sie möglicherweise keine rechtzeitigen Updates.",
    saving: actionCopyDe.saving,
    creating: "Erstellen...",
    organisation: listCopyDe.organisation,
    organisationMissing: "Organisation fehlt",
    addOrganisation: "Organisation hinzufügen",
    joinOrganisation: "Organisation beitreten",
    organisationMissingDescription: "Bitte treten Sie einer Organisation bei, um Tagebücher zu erstellen.",
    addOrganisationToContinue: "Bitte fügen Sie eine Organisation hinzu, um fortzufahren",
    informationMissing: "Information fehlt",
    role: listCopyDe.role,
    openMenu: "Menü öffnen",
    showUsers: "Benutzer anzeigen",
    showQrCode: "QR-Code anzeigen",
    organisationCode: "Organisationscode",
    organisationCodeDescriptionPrefix:
        "Um einer Organisation beizutreten, verwenden Sie bitte den Code, den Sie erhalten haben. Wenn Sie keinen Code haben,",
    requestCode: "fordern Sie einen Code an",
    cantFindOrganisation: "Sie finden Ihre Organisation nicht?",
    addOrganisationYourself: "Selbst hinzufügen",
    newOrganisationName: "Name der Organisation",
    searchExistingOrganisation: "Stattdessen nach einer bestehenden Organisation suchen",
    addNewOrganisation: "Organisation hinzufügen",
    addNewOrganisationDescription:
        "Wir legen sie an und fügen Sie als Kliniker hinzu. Kolleginnen und Kollegen können Sie danach einladen.",
    delete: actionCopyDe.delete,
    deleting: actionCopyDe.deleting,
    rolePatient: "Patient",
    roleClinician: "Behandler",
    roleSecretary: "Sekretariat",
    roleAdmin: "Administrator",
    roleManager: "Manager",
    roleValidator: "Validator",
    roleAuditor: "Auditor",
    organisationDescription: "Dies ist der Name Ihrer Klinik, Praxis oder Ihres Krankenhauses.",
    profileOrganisationDescription:
        "Wenn Sie eine Organisation hinzufügen, können Daten zwischen Ihnen und der Organisation geteilt werden.",
    yourOrganisation: "Ihre Organisation",
    professional: "Berufliche Angaben",
    medicalSpecialty: "Medizinisches Fachgebiet",
    selectSpecialty: "Fachgebiet auswählen",
    specialtyDescription: "Wir erstellen Vorlagen passend zu Ihrem Fachgebiet.",
    professionalRegistrationNumber: "Berufsregistrierungsnummer (optional)",
    professionalRegistrationPlaceholder: "GMC, HCPC oder andere Registrierungsnummer",
    professionalRegistrationDescription: "Ihre GMC-, HCPC- oder Berufsverbands-Registrierungsnummer",
    welcomeTitle: "Willkommen bei Patient Watch!",
    welcomePatientDescription: "Helfen Sie, Behandlung und Forschung zu verbessern, indem Sie Ihre Genesung verfolgen.",
    welcomeClinicianDescription:
        "Bieten Sie Patientinnen und Patienten personalisierte Versorgung, sparen Sie Termine und gewinnen Sie wertvolle Einblicke in Ihre Behandlungen.",
    welcomeSecretaryDescription: "Verwalten Sie Patientendaten und koordinieren Sie Versorgung effizient im Team.",
    welcomeManagerDescription: "Verfolgen Sie, wie Daten in Ihrer Organisation erfasst werden.",
    settingUpAccount: "Ihr Konto wird eingerichtet...",
    gettingAccountReady: "Wir bereiten alles für Sie vor.",
    continueToProfileSetup: "Mit der Profileinrichtung fortfahren",
    processingNewUser: "Neuer Benutzer wird verarbeitet",
    onboardingComplete: "Einrichtung abgeschlossen",
    authenticationError: "Authentifizierungsfehler",
    setupMoment: "Einen Moment bitte, wir richten alles ein...",
    settingUpDiary: "Ihr Tagebuch wird eingerichtet...",
    almostThere: "Fast geschafft!",
    patientSetupCompleteDescription:
        "Danke, dass Sie die Einrichtung abgeschlossen haben. Tragen Sie Ihre Tagebucheinträge nach und nach ein, dann sehen Sie Ihre Werte im Fortschrittsdiagramm.",
    setupCompleteDescription: "Sie können Patient Watch jetzt nutzen, um Ihre Fortschritte zu teilen.",
    supportMessage: "Bitte senden Sie eine Nachricht an support@patient-watch.com",
    retry: actionCopyDe.retry,
    edit: actionCopyDe.edit,
    current: "Aktuell",
    change: "Ändern",
    deleteAccount: "Konto löschen",
    deleteAccountConfirmTitle: "Sind Sie absolut sicher?",
    deleteAccountConfirmDescription:
        'Diese Aktion kann nicht rückgängig gemacht werden. Geben Sie zur Bestätigung "delete my account" ein.',
    deleteAccountPageDescription: "Ihr Konto und alle zugehörigen Daten dauerhaft löschen",
    deleteAccountReason: "Grund für die Kontolöschung",
    deleteAccountSubmit: "Konto löschen",
    submitting: actionCopyDe.submitting,
    deleteAccountConfirmationLabel: "Bestätigung",
    deleteAccountPlaceholder: 'Geben Sie "delete my account" ein',
    deletingAccount: "Löschen...",
    warningNotificationsDisabled: "Warnung: Benachrichtigungen deaktiviert",
    editPreferences: "Einstellungen bearbeiten",
    remindersDescription: "Erinnerungen sind entscheidend dafür, wie Patient Watch Ihre Gesundheit unterstützt.",
    receiveEmailReminders: "E-Mail-Erinnerungen erhalten.",
    receiveSmsReminders: "SMS-Erinnerungen erhalten.",
    pushNotificationSettingsError:
        "Um Push-Benachrichtigungen zu aktivieren, müssen Sie Benachrichtigungen in Ihren App-Einstellungen erlauben.",
    actionRequired: (count) => `Aktion erforderlich (${count})`,
    actionRequiredForms: (count) => `Aktion erforderlich (${count} ${count === 1 ? "Formular" : "Formulare"})`,
    diaryCardDescription:
        "Tagebücher sind Ihre persönlichen Gesundheitsprotokolle und helfen, Behandlung und Forschung zu verbessern.",
    formDue: (count) =>
        `Sie haben ${count} ${count === 1 ? "Formular" : "Formulare"}, ${
            count === 1 ? "das" : "die"
        } ausgefüllt werden ${count === 1 ? "muss" : "müssen"}.`,
    diariesNeedAttention: (count) =>
        `Sie haben ${count} ${count === 1 ? "Tagebuch" : "Tagebücher"} mit Formularen, die Ihre Aufmerksamkeit erfordern.`,
    welcomeModalTitle: (name: string) => `Willkommen, ${name}!`,
    welcomeDescription: "Ihr Konto ist eingerichtet und Ihre Fachvorlagen sind einsatzbereit.",
    welcomeTestPatientTitle: "Testen Sie es mit einem Testpatienten",
    welcomeTestPatientDescription:
        "Um zu sehen, wie Ihre Patientinnen und Patienten Patient Watch erleben, laden Sie einen Testbenutzer mit einer anderen E-Mail-Adresse ein.",
    welcomeAddFirstPatient: "Meinen ersten Patienten hinzufügen",
    welcomeDoctorFallback: "Arzt",
    closeBanner: "Banner schließen",
    home: "Startseite",
    currentPlan: "Aktueller Tarif",
    currentPlanDescription: "Ihr Abonnement und Ihr Tagebuchkontingent",
    noActiveSubscription: "Sie haben kein aktives Abonnement",
    billingStatus: "Status",
    nextBillingDate: "Nächstes Abrechnungsdatum",
    accessUntil: "Zugang bis",
    planDetails: "Tarifdetails",
    trialPlanDetails: "5 neue Tagebücher pro Abrechnungszeitraum",
    enterprisePlanDetails: "Unbegrenzte Tagebücher",
    choosePlanToStart: "Wählen Sie einen Tarif, um mit Patient Watch zu starten",
    upgradeYourPlan: "Tarif upgraden",
    changeYourPlan: "Tarif ändern",
    availablePlans: "Verfügbare Tarife",
    upgradePlanDescription: "Wechseln Sie von Free zu Starter oder Pro für ein höheres Tagebuchkontingent",
    changePlanDescription: "Vergleichen Sie Tarife und ändern Sie Ihr Abonnement",
    choosePlanDescription: "Wählen Sie den Tarif, der am besten zu Ihnen passt",
    preferStartFree: "Lieber kostenlos starten?",
    createFreeAccount: "Kostenloses Konto erstellen",
    needMore: "Mehr Bedarf? Sehen Sie sich unseren",
    enterprisePlan: "Enterprise-Tarif",
    cancelSubscription: "Abonnement kündigen",
    managePaymentMethod: "Zahlungsmethode verwalten",
    undoCancellationHint:
        "Möchten Sie Ihren Tarif behalten? Nutzen Sie Zahlungsmethode verwalten, um Stripe zu öffnen und die Kündigung rückgängig zu machen.",
    paymentRequired: "Zahlung erforderlich",
    paymentOverdue:
        "Ihre Zahlung ist überfällig. Bitte aktualisieren Sie Ihre Zahlungsmethode, um Patient Watch weiter zu nutzen.",
    subscriptionCanceling: "Abonnement wird gekündigt",
    subscriptionCancelingOn: (date) => `Ihr Abonnement wird am ${date} gekündigt. Bis dahin behalten Sie den Zugang.`,
    subscriptionCancelingPeriod:
        "Ihr Abonnement wird zum Ende des Abrechnungszeitraums gekündigt. Bis dahin behalten Sie den Zugang.",
    subscriptionCancelled: "Abonnement gekündigt",
    subscriptionCancelledDescription:
        "Ihr bezahltes Abonnement ist beendet. Wählen Sie unten einen Tarif, um die Abrechnung neu zu starten.",
    unableToCancel: "Kündigung nicht möglich",
    unableToChangePlan: "Tarifänderung nicht möglich",
    unableToOpenBillingPortal: "Abrechnungsportal konnte nicht geöffnet werden",
    unableToStartCheckout: "Checkout konnte nicht gestartet werden",
    failedToLoadBilling: "Abrechnungsdaten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
    billingStatusCanceling: "KÜNDIGUNG",
    billingStatusUnknown: "UNBEKANNT",
    pleaseTryAgain: "Bitte versuchen Sie es erneut.",
    planStarter: "Starter",
    planPro: "Pro",
    perMonth: "/Monat",
    currentPlanBadge: "Aktuell",
    popularBadge: "Beliebt",
    starterDiaries: "20 neue Tagebücher/Monat",
    proDiaries: "50 neue Tagebücher/Monat",
    emailSmsReminders: "E-Mail- und SMS-Erinnerungen",
    emailSupport: "E-Mail-Support",
    prioritySupport: "Priorisierter Support",
    currentPlanButton: "Aktueller Tarif",
    subscribeToStarter: "Starter abonnieren",
    subscribeToPro: "Pro abonnieren",
    downgradeToStarter: "Auf Starter wechseln",
    upgradeToPro: "Auf Pro upgraden",
    includedInEnterprise: "In Enterprise enthalten",
};
